import { isEqual } from 'lodash';

import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { SortAndFiltersByState } from './sortAndFilter.types';

import { SortBy } from '~/core/enums';
import {
  AvailableSortComponents,
  SelectedFilterOptions,
  TypeOfFilter,
} from '~/core/types/sortAndFilter';

const initialSortAndFilter = {
  sortBy: SortBy.TrendingNow,
  filters: [],
  selectedFilters: {},
};

const initialState: SortAndFiltersByState = {
  color: initialSortAndFilter,
  sink: initialSortAndFilter,
  cooking: initialSortAndFilter,
};

const sortAndFilterSlice = createSlice({
  name: 'sortAndFilter',
  initialState,
  reducers: {
    updateSortBy: (
      state,
      action: PayloadAction<{
        component: AvailableSortComponents;
        sortBy: SortBy;
      }>
    ) => {
      const { component, sortBy } = action.payload;

      state[component].sortBy = sortBy;
    },
    updateFilters: (
      state,
      action: PayloadAction<{
        component: AvailableSortComponents;
        filters: TypeOfFilter[];
        selectedFilters: SelectedFilterOptions;
      }>
    ) => {
      const { component, filters, selectedFilters } = action.payload;

      if (!isEqual(state[component].filters, filters)) {
        state[component].filters = filters;
      }
      if (!isEqual(state[component].selectedFilters, selectedFilters)) {
        state[component].selectedFilters = selectedFilters;
      }
    },
    resetFilters: (state, action: PayloadAction<AvailableSortComponents>) => {
      state[action.payload].filters = initialSortAndFilter.filters;
      state[action.payload].selectedFilters =
        initialSortAndFilter.selectedFilters;
    },
    resetAllFilters: (state) => {
      Object.keys(state).forEach((componentKey) => {
        const component = componentKey as AvailableSortComponents;

        state[component].filters = initialSortAndFilter.filters;
        state[component].selectedFilters = initialSortAndFilter.selectedFilters;
      });
    },
  },
});

export const { updateSortBy, updateFilters, resetFilters, resetAllFilters } =
  sortAndFilterSlice.actions;

export default sortAndFilterSlice.reducer;
